document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-mobile-toggle]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const nav=document.querySelector('[data-mobile-nav]');
      if(!nav) return;
      nav.hidden=!nav.hidden;
      btn.setAttribute('aria-expanded', nav.hidden ? 'false' : 'true');
    });
  });
});

/* =================================
   PRODUCT GALLERY + VARIANT PRICING
   ================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* PRODUCT IMAGE GALLERY */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {

    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');

    if (slides.length <= 1) return;

    let current = 0;

    function showImage(index) {

      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides.forEach(function (slide, i) {
        slide.hidden = i !== index;
        slide.classList.toggle('is-active', i === index);
      });

      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });

      current = index;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        showImage(current - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        showImage(current + 1);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showImage(Number(this.dataset.galleryThumb));
      });
    });

  });


  /* VARIANT PRICE + COMPARE-AT PRICE */
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {

    select.addEventListener('change', function () {

      const option = this.options[this.selectedIndex];

      const productInfo = this.closest('.product-info');
      if (!productInfo) return;

      const price = productInfo.querySelector('.price');
      const comparePrice = productInfo.querySelector('[data-compare-price]');
      const addButton = productInfo.querySelector('[data-add-to-cart]');

      if (price) {
        price.textContent = option.dataset.price;
      }

      if (comparePrice) {

        if (option.dataset.comparePrice) {
          comparePrice.textContent = option.dataset.comparePrice;
          comparePrice.hidden = false;
        } else {
          comparePrice.textContent = '';
          comparePrice.hidden = true;
        }

      }

      if (addButton) {

        const available = option.dataset.available === 'true';

        addButton.disabled = !available;
        addButton.textContent = available ? 'Add to Cart' : 'Sold Out';

      }

    });

  });

});